import remark from 'remark';
import remarkHtml from 'remark-html';

export default (input) => {
	return remark()
		.use(remarkHtml)
		.processSync(input)
		.toString();
};
